/* unplugin-vue-components disabled */import { render } from "./RefreshRoute.vue?vue&type=template&id=07c1aa50"
import script from "./RefreshRoute.vue?vue&type=script&lang=js"
export * from "./RefreshRoute.vue?vue&type=script&lang=js"

import exportComponent from "E:\\projects\\internation-fta-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__